module.exports = __webpack_public_path__ + "static/img/bg-tr.f2ce717b.png";